module.exports = __webpack_public_path__ + "img/check-email.c0544a6e.svg";